import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tipcard-info',
  templateUrl: './tipcard-info.component.html',
  styleUrls: ['./tipcard-info.component.scss']
})
export class TipcardInfoComponent implements OnInit {
  constructor(
  ) { }

  ngOnInit(): void {
  }
}
